import { Box, TableHead, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import AlertCircle from '../../../components/AlertCircle';
import { useClientTheme } from '../../../helpers/hooks/useClientTheme';
import { Temperature } from '../../../model/temperature';

const useStyles = makeStyles((theme: any) => ({
  tableCellHeader: {
    '&.MuiTableCell-root': {
      height: '48px',
      textAlign: 'center',
      fontWeight: 700,
    },
  },
  tableCell: {
    '&.MuiTableCell-root': {},
  },
  centerContentCell: {
    '&.MuiTableCell-root': {
      textAlign: 'center',
    },
  },
  emptyCell: {
    '&.MuiTableCell-root': {
      padding: '0px',
      height: '40px',
    },
  },
  dividerCell: {
    '&.MuiTableCell-root': {
      borderTop: 'none',
    },
  },
  headerText: {
    color: 'white',
    textAlign: 'center',
  },
}));

// Shared tag map so the <strong> segments inside the translated clinical copy
// keep their bold styling.
const strongTags = { strong: <strong /> };

const TemperatureInterpretationTableComponent = () => {
  const classes = useStyles();
  const { t } = useTranslation('alertDetail');
  const { theme } = useClientTheme();

  const threshold =
    theme.metrics.temperature.unit === Temperature.Celsius
      ? t('temperature.thresholdCelsius')
      : t('temperature.thresholdFahrenheit');

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: 'primary.main',
        borderRadius: '10px',
        padding: '5px',
      }}
    >
      <Typography className={classes.headerText} component="h5" variant="h5">
        {t('interpretationTable')}
      </Typography>

      <TableContainer
        component={Paper}
        sx={{
          borderRadius: '10px',
          mt: '3px',
        }}
      >
        <Table aria-label="simple table">
          <TableHead>
            <TableCell className={classes.tableCellHeader}>
              <Typography>
                <Trans
                  t={t}
                  i18nKey="temperature.column"
                  components={strongTags}
                />
              </Typography>
            </TableCell>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className={classes.tableCellHeader}>
                <React.Fragment>&nbsp;</React.Fragment>
                <Typography align="left">
                  <Trans
                    t={t}
                    i18nKey="temperature.description"
                    components={strongTags}
                  />
                </Typography>
              </TableCell>
              <TableCell align="center">
                <AlertCircle fill={theme.palette.alertLevel3.main} />
              </TableCell>
              <TableCell className={classes.tableCell}>
                <Typography>
                  <Trans
                    t={t}
                    i18nKey="temperature.event"
                    components={strongTags}
                    values={{ threshold }}
                  />
                </Typography>
              </TableCell>
              <TableCell className={classes.emptyCell} />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TemperatureInterpretationTableComponent;
